import { render, staticRenderFns } from "./academy.vue?vue&type=template&id=a3a5e386&scoped=true"
import script from "./academy.vue?vue&type=script&lang=js"
export * from "./academy.vue?vue&type=script&lang=js"
import style0 from "./academy.vue?vue&type=style&index=0&id=a3a5e386&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a5e386",
  null
  
)

export default component.exports